import { useLocation, useNavigate } from 'react-router-dom';
import DataTableWrapper from '../../../Utility/DataTableWrapper/DataTableWrapper';
import { useContext, useEffect, useRef, useState } from 'react';
import { ComuneService } from '../../../../services/ComuneService';
import { useSelector } from 'react-redux';
import { FormUtility } from '../../../Utility/FormUtility';
import { rolesCodes } from '../../../../constants/Roles';
import Select from '../../../Form/Select';
import ToastContext from '../../../../contexts/toast';
import FiltriAvanzati from '../../../Utility/FiltriAvanzati/FiltriAvanzati';
import Modal from '../../../Utility/Modal/Modal';

export default function GestioneAnagraficaComuni() {
  console.log('inside gestione comuni');

  const [dtOptions, setDtOptions] = useState({});
  const navigate = useNavigate();

  const [province, setProvince] = useState(null);
  const [provincia, setProvincia] = useState(null);

  const [tipologia, setTipologia] = useState(null);

  const [referente, setReferente] = useState(null);

  const [currMapFilters, setCurrMapFilters] = useState(new Map());
  const [nextMapFilters, setNextMapFilters] = useState(null);
  const [advancedFiltersMap, setAdvancedFiltersMap] = useState(null);
  const [nextAdvancedFiltersMap, setNextAdvancedFiltersMap] = useState(null);

  const location = useLocation();

  const [isModalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);

  const [ente, setEnte] = useState(null);
  const [codiceFiscaleReferente, setCodiceFiscaleReferente] = useState(null);

  const [firstLoad, setFirstLoad] = useState(false);

  const toastContext = useContext(ToastContext);

  const roles = useSelector((state) => state.role);
  const utility = new FormUtility({ data: roles });

  const comuneService = new ComuneService();

  const dtRef = useRef();

  useEffect(() => {
    if (location.pathname === '/gestione-adesione-enti') {
      comuneService.getAllProvinceByRegione('Toscana').then(resp => {
        resp.sort((a, b) => a.value.localeCompare(b.value));
        setProvince(resp);
      });
    }
  }, []);

  useEffect(() => {
    if (firstLoad) {
      return;
    }

    const filtri = utility.getFiltriAvanzatiStorage(
      location,
      "_filtri_avanzati"
    );
    setOnLoadFiltriAvanzatiFromStorage(filtri);
    setNextMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());
    setCurrMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());

    setFirstLoad(true);
  }, [firstLoad]);

  const setOnLoadFiltriAvanzatiFromStorage = (filtri) => {
    const filtriAvanzati = advancedFiltersMap ?? new Map();
    const proxMappaFiltri = new Map(nextMapFilters);
    const proxMappaFiltriAvanzati = new Map(nextAdvancedFiltersMap);

    for (const key in filtri) {
      const value = filtri[key];

      let filterValue = value;
      let filtroAvanzato = value;
      switch (key) {
        case "Referente":
          filterValue = filterValue === 'Enti con referente' ? true : filterValue === 'Enti senza referente' ? false : null
          break;
        default:
          break;
      }

      onChangeFilter(key, filterValue, proxMappaFiltri, proxMappaFiltriAvanzati, false);
      filtriAvanzati.set(key, filtroAvanzato);
    }

    setNextAdvancedFiltersMap(new Map(filtriAvanzati));
    setAdvancedFiltersMap(new Map(filtriAvanzati));
  };

  const goToGestioneEnte = () => {
    navigate('/gestione-anagrafica-comune');
  };

  const gotoGestioneOperatori = (enteId) => {
    const route = location.pathname === '/gestione-adesione-enti' ? '/anagrafica-referente/' + enteId : '/gestione-operatori/' + enteId;
    navigate(route);
  };

  const gotoModificaEnte = (enteId) => {
    navigate('/gestione-anagrafica-comune/' + enteId);
  };

  const eliminaComune = (comune) => {
    setEnte(comune);
    setCodiceFiscaleReferente(null);
    setTitle('Eliminazione ente');
    setContent('Confermare eliminazione ente selezionato?');
    setModalOpen(true);
  };

  const handleModalAction = () => {
    if (!codiceFiscaleReferente && ente) {
      comuneService.delete(ente.id).then(() => {
        dtRef.current.rerenderDatatable();
        toastContext.success('Ente eliminato con successo!', 6000);
        setModalOpen(false);
      });
    } else {
      comuneService
        .rimuoviReferenteDaComune(ente, codiceFiscaleReferente.split(' ').pop())
        .then(() => {
          dtRef.current.rerenderDatatable();
          toastContext.success('Referente rimosso da ente con successo!', 6000);
          setModalOpen(false);
        })
        .catch((error) => {
          toastContext.error(utility.getErrorMsg(error), 12000);
        });
    }
  }

  const rimuoviReferenteDaComune = (enteId, codiceFiscaleReferente) => {
    setEnte(enteId);
    setCodiceFiscaleReferente(codiceFiscaleReferente);
    setTitle('Rimozione referente');
    setContent('Confermare rimozione referente selezionato?');
    setModalOpen(true);
  }

  const editReferente = (enteId, codiceFiscaleReferente) => {
    navigate('/anagrafica-referente/' + enteId + '/' + codiceFiscaleReferente.split(' ').pop());
  }

  const setFiltriAvanzatiInStorage = (mapFilters) => {
    const obj = Object.fromEntries(mapFilters);
    sessionStorage.setItem(
      `${location.pathname}_filtri_avanzati`,
      JSON.stringify(obj)
    );
  };

  const onChangeFilter = async (type, val, mappaFiltri, mappaFiltriAvanzati, updateNextMap = true, updateMap = false) => {
    let mapValue = val;
    let mapAvanzatoValue = val;

    switch (type) {
      case "Provincia":
        setProvincia(val);
        break;
      case "Referente":
        mapValue = val ? val === 'true' ? 'Enti con referente': 'Enti senza referente' : null;
        setReferente(val + '');
        break;
      case "Tipologia":
        setTipologia(val);
        break;
      default:
        break;
    }

    if (!mapValue) {
      mappaFiltri.delete(type);
      mappaFiltriAvanzati.delete(type);
    } else {
      mappaFiltri.set(type, mapValue);
      mappaFiltriAvanzati.set(type, mapAvanzatoValue);
    }

    if (updateNextMap) {
      setNextMapFilters(new Map(mappaFiltri));
      setNextAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
    }

    if (!updateMap) {
      return;
    }

    setCurrMapFilters(new Map(mappaFiltri));
    setAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
    setFiltriAvanzatiInStorage(new Map(mappaFiltri));
  };

  const getReferente = (referente) => {
    const splitReferente = referente.split(' ');
    const codiceFiscale = splitReferente.pop();
    const nomeCognome = splitReferente.slice().join(' ');
    return <span className='rtds-text-left'>{nomeCognome}<br hidden={!nomeCognome}/>{codiceFiscale}</span>;
  }

  useEffect(() => {
    if (!firstLoad) {
      return;
    }

    createDtOptions();
    loadData();
  }, [currMapFilters]);

  const createDtOptions = () => {
    const dtOpt = {
      columns: [
        {
          name: 'Id',
          data: 'id',
          visible: true,
          sortable: true,
          searchable: false,
        },
        {
          name: 'Denominazione',
          data: 'denominazione',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Tipologia',
          data: 'tipologia',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Cod. Istat',
          data: 'codice',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Provincia',
          data: 'denominazioneProvincia',
          visible: true,
          sortable: true,
          searchable: false,
        },
        {
          name: 'Comuni dell’Ente',
          data: 'enti',
          visible: true,
          sortable: false,
          searchable: false,
          cell: (row, col) =>
            <>
              <div className='rtds-justify-between rtds-flex' hidden={!row.ente}>
                <span className='lg:rtds-hidden rtds-font-semibold'>
                  {col.name}
                </span>  
                <div>
                  <p>
                    <strong>Ente di appartenenza:</strong><br/><span>{row.ente}</span>
                  </p>
                </div>
              </div>

              <div className='rtds-justify-between rtds-flex' hidden={!row.capofila}>
                <span className='lg:rtds-hidden rtds-font-semibold'>
                  {col.name}
                </span>  
                <div>
                 
                 
                  <ul ariaLabel="Enti associati">
                    {
                      row.enti?.map((ca) => (
                        <li key={ca.id} >&#x2022;&nbsp;{ca} {row.capofila === ca && <strong>(Capofila)</strong>}</li>

                        
                      ))
                    }
                  </ul>
                </div>
              </div>
            </>
        },
        {
          name: '# Operatori',
          data: null,
          visible: location.pathname.startsWith('/gestione-anagrafica-operatori'),
          sortable: false,
          searchable: false,
          cell: (row, col) => row.utenti?.length,
        },
        {
          name: 'Referente',
          data: 'referenti',
          visible: location.pathname === '/gestione-adesione-enti',
          sortable: true,
          searchable: true,
          center: true,
          cell: (row, col) => (
            <>
              <div className='rtds-justify-between rtds-flex' hidden={row.referenti?.length === 0}>
                <span className='lg:rtds-hidden rtds-font-semibold' hidden={!row.referenti?.length > 0}>
                  {col.name}
                </span> 
                <ul aria-labelledby='col6'>
                  {
                    row.referenti?.map((referente) => (
                      <li className='rtds-flex rtds-items-center' key={referente}>
                        <button
                          type='button' 
                          className='rtds-btn rtds-btn--icon rtds-btn--danger rtds-btn--s'
                          title='Premi per rimuovere il referente'
                          onClick={() => rimuoviReferenteDaComune(row.id, referente)}
                        >
                          <svg className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4' aria-hidden='true' focusable='false' role='img'>
                            <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--minus`} />
                          </svg>
                          <span className='rtds-sr-only'>Rimuovi referente</span>
                        </button>&nbsp;
                        <button
                          type='button'
                          className='rtds-btn rtds-btn--icon rtds-btn--secondary rtds-btn--s'
                          title='Premi per modificare il referente'
                          onClick={() => editReferente(row.id, referente)}
                        >
                          <svg className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4' aria-hidden='true' focusable='false' role='img'>
                            <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--pencil-square`} />
                          </svg>
                          <span className='rtds-sr-only'>Modifica referente</span>
                        </button>&nbsp;{getReferente(referente)}
                      </li>
                    ))
                  }
                </ul>
              </div>
              <button
                type='button'
                className='rtds-btn rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button rtds-text-center'
                onClick={() => gotoGestioneOperatori(row.id)}
                hidden={row.referenti?.length > 0}
                disabled={row.dataFineValidita || !!row.ente}
                title={!!row.ente ? 'Comune appartenente ad un\'ente' : row.dataFineValidita ? 'Comune dismesso' : 'Associa referente'}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--user-plus`}
                  />
                </svg>
                Associa Referente
              </button>
            </>
          ),
        },
        {
          name: 'Azioni',
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => (
            <div
              className='rtds-inline-flex rtds-gap-1'
              role='group'
              aria-label='Azioni'
            >
              <button
                type='button'
                className='rtds-btn rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                onClick={() => gotoGestioneOperatori(row.id)}
                hidden={location.pathname !== '/gestione-anagrafica-operatori'}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--user`}
                  />
                </svg>
                Operatori
              </button>{' '}
              <button
                type='button'
                className='rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                onClick={() => gotoModificaEnte(row.id)}
                hidden={location.pathname !== '/gestione-adesione-enti' || row.tipologia === 'Comune'}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--pencil-square`}
                  />
                </svg>
                Modifica
              </button>{' '}
              <button
                type='button'
                className='rtds-btn--danger rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                onClick={() => eliminaComune(row)}
                disabled={row.richieste?.length > 0}
                hidden={location.pathname !== '/gestione-adesione-enti' || row.tipologia === 'Comune'}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 rtds-transition-all group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--trash`}
                  />
                </svg>
                Elimina
              </button>
            </div>
          ),
        }, { data: 'dataFineValidita', searchable: false, sortable: false, omit: true }
      ],
      serverSide: true,
      ajax: comuneService.getAllDt,
      ajaxParams: {
        entiId: utility.checkRoles([rolesCodes.comune, rolesCodes.comuneReferente])
          ? roles.operatori.map(c => c.id)
          : null,
        forLibrerie: location.pathname.startsWith('/gestione-comuni-librerie'),
        provincia: provincia,
        tipologia: tipologia,
        hasReferente: referente
      },
      rows: [
        /*{ id: 1, title: 'test 123', year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative comune del 23/24' }*/
      ],
      sorts: [],
      hideSearch: false,
      title: 'Elenco Enti'
    };
    setDtOptions(dtOpt);
  }

  const loadData = async () => {
    // let rows= [];
    // for (let i = 1;i<400;i++){
    //     rows.push({ id: i, title: 'test ' + i, year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative comune del 23/24' });
    // }
    // setDtOptions((dtOptions)=> ({...dtOptions,rows}));
  };

  const onSearch = async () => {
    setCurrMapFilters(new Map(nextMapFilters));
    setAdvancedFiltersMap(new Map(nextAdvancedFiltersMap));
    setFiltriAvanzatiInStorage(nextMapFilters);
  };

  return (
    <>
      <div className='rtds-container rtds-py-6'>
        <div className='rtds-grid rtds-gap-6 xl:rtds-gap-8'>
          <div className='rtds-flex rtds-items-center rtds-justify-between'>
            <h1 className='rtds-heading-2'>{location.pathname === '/gestione-adesione-enti' ? 'Anagrafe Enti' : location.pathname.startsWith('/gestione-anagrafica-operatori') ? 'Operatori Comunali' : 'Elenco Enti'}</h1>
          </div>

          <FiltriAvanzati
            hidden={location.pathname !== '/gestione-adesione-enti'}
            mapFilters={currMapFilters}
            onRemoveFilter={(type) => onChangeFilter(type, null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap), true, true)}
          >
            <div className='rtds-grid rtds-gap-3'>
              <div className='rtds-field-row'>
                <Select
                  classDiv={'rtds-mt-0 lg:rtds-mt-0'}
                  label={'Tipologia'}
                  id={'tipologia'}
                  classSelect={''}
                  onChange={(event) => onChangeFilter('Tipologia', event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap))}
                  baseOption={'Nessuna selezione'}
                  bindKey={'key'}
                  bindValue={'key'}
                  options={[{ key: 'Comune' }, { key: 'Unione di Comuni' }, { key: 'Gestione Associata' }]}
                  value={tipologia || ''}
                />
                <Select
                  classDiv={'rtds-mt-3 lg:rtds-mt-0'}
                  label={'Provincia'}
                  id={'provincia'}
                  classSelect={''}
                  onChange={(event) => onChangeFilter('Provincia', event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap))}
                  baseOption={'Nessuna selezione'}
                  options={province}
                  bindValue={'key'}
                  value={provincia || ''}
                />
              </div>

              <div className='rtds-field-row'>
                <Select
                  classDiv={'rtds-mt-0 lg:rtds-mt-0'}
                  label={'Referente'}
                  id={'referente'}
                  classSelect={''}
                  onChange={(event) => onChangeFilter('Referente', event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap))}
                  baseOption={'Nessuna selezione'}
                  bindKey={'key'}
                  bindValue={'value'}
                  options={[{ key: true, value: 'Enti con Referente' }, { key: false, value: 'Enti senza Referente' }]}
                  value={referente || ''}
                />
              </div>
              <div className='rtds-form-actions rtds-flex rtds-justify-start'>
                <button type='button' className='rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--secondary' onClick={() => onSearch()}>
                  Cerca
                  <svg className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:rtds-translate-x-1' aria-hidden='true' focusable='false' role='img'>
                    <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`} />
                  </svg>
                </button>
              </div>
            </div>
          </FiltriAvanzati>
        </div>
      </div>

      <DataTableWrapper
        ref={dtRef}
        dtOptions={dtOptions}
        headerButton={
          <button
            type='button'
            className='rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button'
            onClick={goToGestioneEnte}
            hidden={utility.checkRoles([rolesCodes.comune, rolesCodes.comuneReferente])}
          >
            <svg
              className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
              aria-hidden='true'
              focusable='false'
              role='img'
            >
              <use
                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus-circle`}
              />
            </svg>
            Inserisci&nbsp;nuovo&nbsp;Ente
          </button>
        }
      />

      <Modal
        isOpen={isModalOpen}
        title={title}
        content={content}
        onClose={() => setModalOpen(false)}
        onAction={handleModalAction}
        actionLabel='Conferma'
        closeLabel='Annulla'
      />
    </>
  );
}
